import React from "react";
import { useTranslation } from "react-i18next";
import { useDepartementCount } from "../../context/DepartementCountContext";

const DepartementCountBadge = () => {
  const { t } = useTranslation();
  const { departementCount, loading, error } = useDepartementCount();

  if (loading) {
    return (
      <span className="ml-1 bg-muted text-muted-foreground text-xs font-medium px-2 py-0.5 rounded-full animate-pulse">
        --
      </span>
    );
  }

  if (error) {
    return (
      <span
        className="ml-1 bg-red-950/30 text-red-400 text-xs font-medium px-2 py-0.5 rounded-full"
        title={`${t("common.error")}: ${error}`}
      >
        ⚠
      </span>
    );
  }

  return (
    <span className="ml-1 bg-muted text-muted-foreground text-xs font-semibold px-2 py-0.5 rounded-full">
      {departementCount}
    </span>
  );
};

export default DepartementCountBadge;
